<div [ngClass]="backgroundClass">
    <div class="container-fluid">
        <div class="row align-items-center" style="min-height: 100vh;">
            <!-- Left Side - Empty or future content -->
            <div class="col-md-6"></div>

            <!-- Right Side - Login Form -->
            <div class="col-md-6">
                <div class="login-card">
                    <div class="portal-header">
                        <h2>Aggregator Portal</h2>
                        <p class="subtitle">Assemble Land Intelligently</p>
                    </div>

                    <div class="features-list">
                        <h4>Unlock Powerful Features:</h4>
                        <ul>
                            <li *ngFor="let services of servicesOffering">
                                <span class="check-mark">✓</span> {{services}}
                            </li>
                        </ul>
                    </div>

                    <form>
                        <div class="form-group">
                            <input type="text" class="form-control" [(ngModel)]="loginUserData.email" name="email"
                                placeholder="User Name/Email Address" #username="ngModel" required>
                        </div>
                        <div class="form-group position-relative">
                            <input [type]="show_button ? 'text' : 'password'" name="password" class="form-control"
                                [(ngModel)]="loginUserData.password" placeholder="Password" required>
                            <i [class]="show_eye ? 'fa fa-eye' : 'fa fa-eye-slash'" (mouseup)="showPassword()"
                                (mousedown)="showPassword()"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                        </div>
                        <button type="submit" class="btn btn-login" (click)="Submit()">Manage Your Assembly</button>
                    </form>

                    <div class="form-footer">
                        <label class="checkbox-label">
                            <input type="checkbox"> Remember me
                        </label>
                        <a href="#" class="forgot-password">Forgot Password?</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="copyright">
        {{copyrightMessage}}
    </div>
</div>